import Vue from 'vue';
import Router from 'vue-router';

//A-Z
import Home from './views/Home.vue';
import Campaign from './views/Campaign.vue';
import History from './views/History.vue';

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/campaign/:campaignId",
            name: "campaign",
            component: Campaign,
        },
        {
            path: "/history",
            name: "history",
            component: History,
            children: [
                {
                  name: 'detail_history',
                  path: '/:campaignId/:form',
                  component: Campaign
                },
              ]
        },
        
        {
            path: '/',
            name: 'home',
            component: Home,
            children: [
                {
                  name: 'detail',
                  path: '/:campaignId',
                  component: Campaign
                },
              ]
        },
        
        
    ]
})
